module.exports = __webpack_public_path__ + "img/img_index_cha_01@2x.2da9e008.png";